import { Component } from 'react';
import * as React from 'react';
import LazyLoad from "vanilla-lazyload";

const config = {
  elements_selector: ".lazy"
}

const lazyLoad = new LazyLoad(config);

export class LazyImage extends React.Component {
  // Update lazyLoad after first rendering of every image
  componentDidMount() {
    lazyLoad.update();
  }

  // Update lazyLoad after rerendering of every image
  componentDidUpdate() {
    lazyLoad.update();
  }

  // Render the image with data-src
  render() {
    const { alt, src, srcset, sizes, width, height, display } = this.props;

    return (
      <img
        alt={alt}
        className="lazy"
        data-src={src}
        data-srcset={srcset}
        data-sizes={sizes}
        width={width}
        height={height}
        style={{ display: display}}
      />
    );
  }
}

export default LazyImage;
